<template>
  <div class="container-directtalk flex"
    :class="{'directtalk-width': !isMenuMiniSize, 'directtalk-width-thin-menu': isMenuMiniSize}">
    <div class="mobile-header-menu">
      <button class="button menu-button" @click="menuSelect()">
        <span class="mdi mdi-format-list-bulleted" style="margin-right: 7px;"></span>Menu</button>
      <button class="button menu-button" @click="chatSelect()">
        <span class="mdi mdi-comment-account" style="margin-right: 7px;"></span>Chat</button>
      <button class="button menu-button" @click="userSelect()">
        <span class="mdi mdi-information-outline" style="margin-right: 7px;"></span>Info</button>
    </div>
    <div class="menu-container">
      <DirectTalkSubMenu @changeView="chatSelect()"></DirectTalkSubMenu>
    </div>
    <div class="chat-container disp-scroll" :class="{'init-room': selectroom.name === ''}">      
      <Chat
        v-if="selectroom.name !== ''"
        :parentComponent="parentComponent"
        >
      </Chat>
      <div class="init-room" v-if="selectroom.name === ''">
        <span class="mdi mdi-door-open mdi-48px"></span>
        <p>チャットルームを選択してください。</p>
      </div>
    </div>
    <div class="nav-container disp-scroll" :class="{'nav-container-closed': !isUserContainer}" v-if="selectroom.name !== ''">
      <button class="button nav-button-close" @click="changeInfoCardView(false)" v-if="isUserContainer">
        ＞
      </button>
      <button class="button nav-button-open" @click="changeInfoCardView(true)" v-if="!isUserContainer">
        ＜
      </button>
    </div>
    <div class="user-container" v-if="isMobileAndSelect">
      <InfoCard v-if="selectroom.name !== ''"></InfoCard>
      <div class="init-room" v-if="selectroom.name === ''">
        <span class="mdi mdi-door-open mdi-48px"></span>
        <p>チャットルームを選択してください。</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import DirectTalkSubMenu from '@/views/DashBoard/DirectTalk/DirectTalkSubMenu'
import Chat from '@/views/DashBoard/DirectTalk/Chat'
import InfoCard from '@/views/DashBoard/DirectTalk/InfoCard'
export default {
  name: 'DirectTalk',
  componentName: 'DirectTalk',
  components: {
    DirectTalkSubMenu,
    Chat,
    InfoCard
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('directtalk', ['selectroom']),
    ...mapState("setting",["isMenuMiniSize"]),
    isMobileAndSelect () {
      console.debug('*** Start *** isMobileAndSelect')
      if (window.innerWidth <= 480 && this.selectroom.name === '') return true
      else if (window.innerWidth > 480 && this.selectroom.name === '') return false
      else return true
    }
  },
  data () {
    return {
      isUserContainer: true,
      isMenuSelect: true,
      parentComponent: "DirectTalk"
    }
  },
  created () {
    var star = {
      'get_type': 'star'
    }
    var search = {
      'get_type': 'search',
      'init': 'ok'
    }
    var all = {
      'get_type': 'all'
    }
    this.$store.dispatch('directtalk/getRoomList', star)
    this.$store.dispatch('directtalk/getRoomList', search)
    this.$store.dispatch('directtalk/getRoomList', all)
  },
  mounted () {
    const uriVO = process.env.WS_ENDPOINT + 'vo/user_list/' + this.user.companyID + '/' + this.user.userHash
    this.$store.dispatch('virtualOffice/connectVirtualOfficeSV', uriVO)
    const con = {'is_connect': true}
    this.$store.dispatch('auth/setUserConnect', con)
  },
  methods: {
    changeInfoCardView (flg) {
      console.debug('*** Start *** changeInfoCardView')
      console.debug('flg: ' + JSON.stringify(flg))
      if (flg) {
        console.info('flg is true')
        var target = document.querySelector('div.user-container')
        console.info('target: ' + JSON.stringify(target))
        if (!target) return
        target.style.display = 'flex'
        target.style.width = '40%'
        var target = document.querySelector('div.chat-container')
        console.info('target: ' + JSON.stringify(target))
        if (!target) return
        target.style.width = 'calc(60% - 200px)'
        this.isUserContainer = true
      } else {
        console.info('flg is false')
        var target = document.querySelector('div.user-container')
        console.info('target: ' + JSON.stringify(target))
        if (!target) return
        target.style.display = 'none'
        var target = document.querySelector('div.chat-container')
        console.info('target: ' + JSON.stringify(target))
        if (!target) return
        target.style.width = 'calc(100% - 200px)'
        this.isUserContainer = false
      }
      console.debug('*** End *** changeInfoCardView')
    },
    menuSelect () {
      console.debug('*** Start *** menuSelect')
      this.isMenuSelect = true
      var target = document.querySelector('div.menu-container')
      console.info('target: ' + JSON.stringify(target))
      if (!target) return
      target.style.height = 'calc(100% - 80px)'
      target.style.display = 'block'
      var target = document.querySelector('div.chat-container')
      console.info('target: ' + JSON.stringify(target))
      if (!target) return
      target.style.height = '0'
      target.style.display = 'none'
      var target = document.querySelector('div.user-container')
      console.info('target: ' + JSON.stringify(target))
      if (!target) return
      target.style.height = '0'
      target.style.display = 'none'
      console.debug('*** End *** menuSelect')
    },
    chatSelect () {
      console.debug('*** Start *** chatSelect')
      this.isMenuSelect = false
      var target = document.querySelector('div.menu-container')
      console.info('target: ' + JSON.stringify(target))
      if (!target) return
      target.style.height = '0'
      target.style.display = 'none'
      var target = document.querySelector('div.chat-container')
      console.info('target: ' + JSON.stringify(target))
      if (!target) return
      target.style.height = 'calc(100% - 80px)'
      target.style.display = 'block'
      var target = document.querySelector('div.user-container')
      console.info('target: ' + JSON.stringify(target))
      if (!target) return
      target.style.height = '0'
      target.style.display = 'none'
      console.debug('*** End *** chatSelect')
    },
    userSelect () {
      console.debug('*** Start *** userSelect')
      this.isMenuSelect = false
      var target = document.querySelector('div.menu-container')
      console.info('target: ' + JSON.stringify(target))
      if (!target) return
      target.style.height = '0'
      target.style.display = 'none'
      var target = document.querySelector('div.chat-container')
      console.info('target: ' + JSON.stringify(target))
      if (!target) return
      target.style.height = '0'
      target.style.display = 'none'
      var target = document.querySelector('div.user-container')
      console.info('target: ' + JSON.stringify(target))
      if (!target) return
      target.style.height = 'calc(100% - 80px)'
      target.style.display = 'block'
      console.debug('*** End *** userSelect')
    }
  }
}
</script>

<style scoped>
.flex{
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
}
.directtalk-width {
  height: 100vh;
  width: calc(100vw - 200px);
}
.directtalk-width-thin-menu {
  height: 100vh;
  width: calc(100vw - 55px);
}
.container-directtalk {
  padding: 0px !important;
  margin: 0px !important;
  background-color: #ffffff;
}
.menu-container {
  width: 200px;
}
.chat-container {
  width: calc(60% - 200px);
}
.user-container {
  width: 40%;
}
.init-room {
  height: 100%;
  width: calc(100% - 280px);
  //overflow-y: scroll !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.mobile-header-menu {
  display: none;
}
.nav-container {
  display: none;
  position: absolute;
  top: 84px;
  left: 57%;
}
.nav-container-closed {
  left: calc(100% - 80px);
}
.nav-button-close {
  border-radius: 50%;
  height: 42px;
}
.nav-button-open {
  border-radius: 50%;
  height: 42px;
}
.menu-button {
  height: calc(100% - 2px);
  width: calc(33% - 1px);
  border-radius: 0;
  background: transparent;
  color: white;
}
@media screen and (max-width: 1000px) {
  .nav-container {
    display: block;
  }
}
@media screen and (max-width: 480px) {
  .container-directtalk {
    display: flex;
    flex-direction: column;
  }
  .init-room {
    width: 100%;
    height: calc(100% - 80px);
    //overflow-y: scroll;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .menu-container {
    width: 100%;
    height: calc(100% - 80px);
  }
  .nav-container {
    display: none;
  }
  .chat-container {
    width: 100%;
    height: 0;
  }
  .user-container {
    width: 100%;
    height: 0;
  }
  .mobile-header-menu {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;
    height: 50px;
    background: rgba(20, 20, 20, 0.6);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/DirectTalk/DirectTalk.vue